module.exports = __webpack_public_path__ + "img/3d_控制柜.c2e79ac2.png";